import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { redirect, useNavigate } from 'react-router-dom';
import axios from 'axios';
import RegistrationDone from '../../components/RegistrationDone';

const API_URL = process.env.REACT_APP_PUBLIC_API_URL 

const RegistrationPage = () => {
  const navigate = useNavigate();
  const [currentSection, setCurrentSection] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [registrationResponse, setRegistrationResponse] = useState(null);
  const [formData, setFormData] = useState({

    // Personal Information
    firstName: '',
    lastName: '',
    middleName: '',
    dateOfBirth: '',
    gender: '',
    ageGroup: '',
    idNumber: '',
    disability: '',
    // Contact Information
    region: '',
    district: '',
    community: '',
    phoneNumber: '',
    email: '',
    whatsapp: '',

    // Education & Employment information
    highestEducation: '',
    enrollmentStatus: '',
    completionStatus: '',
    mainOccupation: '',

    // Agriculture Interested & Engagement
    interestInAgriculture: '',
    valueChainInterest: '',
    currentEngagement: '',

    // Access to Resources Information
    landAccess: '',
    financeAcess: '',
    toolsTechnologyAccess: '',
    mobilephoneAccess: '',

    // Safeguarding Information
    safetyPerception: '',
    riskHarmful: '',
    reportIssues: '',
    safeguardinginfo: ''
  });

  const sections = [
    {
      title: 'Personal Information',
      fields: [
        { name: 'firstName', label: 'First Name', type: 'text', required: true },
        { name: 'lastName', label: 'Last Name', type: 'text', required: true },
        { name: 'middleName', label: 'Middle Name', type: 'text', required: false },
        { name: 'dateOfBirth', label: 'Date of Birth', type: 'text', required: false, placeholder: 'MM/DD/YYYY' },
        { name: 'gender', label: 'Gender', type: 'select', required: true, options: ['Male', 'Female', 'Other', 'Prefer not to say'] },
        { name: 'ageGroup', label: 'Age Group', type: 'select', required: true,         options: ["Early (18 - 23)", "Mid (24 - 29)", "Late (30 - 35)"]},
        { name: 'idNumber', label: 'Ghana Card Number', type: 'text', required: false },
        {
          name: 'disability', label: 'Disability Status', type: 'select', required: false,
          options: ['No', 'Yes - Mobility (difficulty walking, using hands)', 'Yes - Visual impairment (blindness or low vision', 'Yes - Hearing impairment', 'Yes - Psychological disability/mental health', 'Yes - Other']
        },
      ]
    },
    {
      title: 'Contact Information',
      fields: [
        {
          name: 'region', label: 'Region', type: 'select', required: true,
          options: ['Greater Accra', 'Western', 'Eastern', 'Central', 'Volta']
        },
        { name: 'district', label: 'District', type: 'text', required: false },
        { name: 'community', label: 'Community/Town', type: 'text', required: false },
        { name: 'phoneNumber', label: 'Phone', type: 'tel', required: true },
        { name: 'email', label: 'Email', type: 'email', required: false },
        { name: 'whatsapp', label: 'Whatsapp Phone', type: 'phone', required: false },
      ]
    },

    {
      title: 'Agriculture Interested & Engagement',
      fields: [
        {
          name: 'interestInAgriculture', label: 'Interest in Agriculture', type: 'select',
          options: ['Yes - as a business / income-generating activity', 'Yes - as a hobby/substinence (non-income)', 'Yes - assisting parents/guardian', 'No - not engaged']
        },

        {
          name: 'valueChainInterest', label: 'Value Chain Interest', type: 'select',
          options: [
            'Vegetables',
            'Tree Crops',
            'Poultry Production',
            'Livestock Production',
            'Beekeeping',
            'Farm Planning and Management',
            'Agribusiness and Financial Management',
            'Marketing of Agric Produce',
            'Entrepreneurship',
            'Career & Counselling Guidance for SHS'
          ]
        },

        {
          name: 'currentEngagement', label: 'Already engaged in Agricultural Activities?', type: 'select', options:
            ['Yes - As a business/income generating activity', 'Yes - as a hobby/substinence (non-income)', 'Yes - assisting parents/guardian', 'No - not engaged']
        }
      ]
    },
    {
      title: 'Education & Employment',
      fields: [
        {
          name: 'highestEducation', label: 'Highest Level of Education', type: 'select', required: true,
          options: ['No formal education', 'Primary', 'JHS', 'SHS', 'TVET', 'Diploma', 'Bachelor\'s Degree', 'Master\'s Degree', 'PhD', 'Other']
        },
        { name: 'enrollmentStatus', label: 'Aree you currently enrolled in School, College or Training?', type: 'select', required: false, options: ['Yes - full-time', 'Yes - Part Time', 'No'] },
        { name: 'completionStatus', label: 'Completion Status', type: 'select', required: false, options: ['Yes - Completed and not Currently Studying', 'No - Currently Studying and not yet Completed', 'Not Applicable (Never Enrolled)'] },
        {
          name: 'mainOccupation', label: 'Occupation', type: 'select', required: false,
          options: ['Student', 'Wage Employement (informal)', 'Employment salary (formal)', 'Unemployed / Seeking work', 'Self-employed (non-agriculture)', 'Apprentice/trainee']
        },

      ]
    },
    {
      title: 'Access to Resources',
      fields: [
        {
          name: 'landAccess', label: 'Land Access', type: 'select', required: true,
          options: ['Yes - Own Land', 'Yes - Rented/Leased', 'Yes - Family land (informal access)', 'No Access to Land']
        },
        {
          name: 'financeAccess', label: 'Finance Access', type: 'select', required: true,
          options: ['Yes - formal loan (Bank, Microfinance)', 'Yes - Informal Loan or Savings Group', 'No Access to Finance']
        },

        { name: 'toolsTechnologyAccess', label: 'Tools/Technology Access', type: 'select', required: false, options: ['Yes - Own', 'Yes - Borrow/Shared', 'No'] },

        {
          name: 'mobilephoneAccess', label: 'Availability', type: 'select', required: true,
          options: ['Yes - smartphone with internet access', 'Yes - basic phone (call/text only)', 'No phone']
        },
      ]
    },
    {
      title: 'Safeguarding',
      fields: [
        {
          name: 'safetyPerception', label: 'Do you feel safe participating in community agriculture activities?', type: 'select', required: false,
          options: ['Always', 'Sometimes', 'Rarely', 'Never']
        },
        {
          name: 'riskHarmful', label: 'Risks or Harmful Practices Hindering you?', type: 'select', required: true,
          options: ['Yes', 'No']
        },
        {
          name: 'reportIssues', label: 'Who You Would Report Issues to', type: 'select', required: true,
          options: ['Community Leader', 'Project staff', 'Familiy member', 'No one', 'Other']
        },
        {
          name: 'safeguardinginfo', label: 'Do You Want Safeguarding Info?', type: 'select', required: false,
          options: ['Yes', 'No']
        }
      ]
    }
  ];

  const validateSection = (sectionIndex) => {
    const section = sections[sectionIndex];
    const newErrors = {};

    section.fields.forEach(field => {
      if (field.required && !formData[field.name]?.trim()) {
        newErrors[field.name] = `${field.label} is required`;
      }

      if (field.type === 'email' && formData[field.name]) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData[field.name])) {
          newErrors[field.name] = 'Please enter a valid email address';
        }
      }

      if (field.type === 'tel' && formData[field.name]) {
        const phoneRegex = /^[0-9+\-\s()]+$/;
        if (!phoneRegex.test(formData[field.name])) {
          newErrors[field.name] = 'Please enter a valid phone number';
        }
      }

      const minAge = 18;
      const maxAge = 35;

      if (field.name === 'dateOfBirth' && formData[field.name]) {
        // Convert MM/DD/YYYY to YYYY-MM-DD for validation
        const dateParts = formData[field.name].split('/');
        if (dateParts.length === 3) {
          const [month, day, year] = dateParts;
          const dateValue = `${year}-${month}-${day}`;
          const birthDate = new Date(dateValue);
          const today = new Date();
          const age = today.getFullYear() - birthDate.getFullYear();
          const monthDiff = today.getMonth() - birthDate.getMonth();
          const actualAge = monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate()) ? age - 1 : age;

          if (actualAge < minAge || actualAge > maxAge) {
            newErrors[field.name] = 'You must be between 18 and 35 years old';
          }
        }
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleDateChange = (value) => {
    // Remove all non-numeric characters
    let cleaned = value.replace(/\D/g, '');
    
    // Limit to 8 digits (MMDDYYYY)
    cleaned = cleaned.substring(0, 8);
    
    // Add slashes automatically
    let formatted = cleaned;
    if (cleaned.length >= 2) {
      formatted = cleaned.substring(0, 2) + '/' + cleaned.substring(2);
    }
    if (cleaned.length >= 4) {
      formatted = cleaned.substring(0, 2) + '/' + cleaned.substring(2, 4) + '/' + cleaned.substring(4);
    }
    
    return formatted;
  };

  const handleInputChange = (name, value) => {
    let sanitizedValue = value;

    if (typeof value === 'string') {
      sanitizedValue = value
        .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
        .replace(/javascript:/gi, '')
        .replace(/on\w+\s*=/gi, '');
    }

    // Special handling for date of birth field
    if (name === 'dateOfBirth') {
      sanitizedValue = handleDateChange(sanitizedValue);
    }

    setFormData(prev => ({
      ...prev,
      [name]: sanitizedValue
    }));

    if (errors[name]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const handleNext = () => {
    if (validateSection(currentSection)) {
      if (currentSection < sections.length - 1) {
        setCurrentSection(currentSection + 1);
      }
    }
  };

  const handlePrevious = () => {
    if (currentSection > 0) {
      setCurrentSection(currentSection - 1);
    }
  };

  const submitform = async () => {
    if (!validateSection(currentSection)) {
      redirect('/');
    }

    // Validate all sections before submission
    let allValid = true;
    for (let i = 0; i < sections.length; i++) {
      if (!validateSection(i)) {
        allValid = false;
        setCurrentSection(i);
        break;
      }
    }

    if (!allValid) {
      return;
    }

    setIsSubmitting(true);

    try {
      const sanitizedData = {};
      Object.keys(formData).forEach(key => {
        let value = formData[key];
        if (typeof value === 'string') {
          value = value
            .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
            .replace(/javascript:/gi, '')
            .replace(/on\w+\s*=/gi, '')
            .trim();
        }
        sanitizedData[key] = value;
      });

      const response = await axios.post(`${API_URL}/registration`, sanitizedData, {
        headers: {
          'Content-Type': 'application/json',
        },
        timeout: 30000,
      });

      const data = response.data

      if (data.success) {
        setRegistrationResponse(data);
        setRegistrationSuccess(true);
        return;
      } else {
        setErrors({ submit: data.message || 'Error Creating New Registrant' });
      }
    } catch (error) {
      console.error('Registration error:', error);
      setErrors({
        submit: error.response?.data?.message
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const renderField = (field) => {
    const value = formData[field.name] || '';
    const error = errors[field.name];
    const hasError = !!error;

    return (
      <div key={field.name} className="mb-4 sm:mb-6">
        <label className="block text-sm sm:text-base font-medium text-gray-700 mb-2">
          {field.label}
          {field.required && <span className="text-red-500 ml-1">*</span>}
        </label>

        {field.type === 'select' ? (
          <select
            value={value}
            onChange={(e) => handleInputChange(field.name, e.target.value)}
            className={`w-full px-4 py-2 sm:py-3 rounded-lg border ${hasError
              ? 'border-red-500'
              : 'border-gray-300'
              } bg-white text-gray-900 focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors`}
            required={field.required}
          >
            <option value="">Select {field.label}</option>
            {field.options?.map(option => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        ) : field.type === 'textarea' ? (
          <textarea
            value={value}
            onChange={(e) => handleInputChange(field.name, e.target.value)}
            rows={4}
            className={`w-full px-4 py-2 sm:py-3 rounded-lg border ${hasError
              ? 'border-red-500'
              : 'border-gray-300'
              } bg-white text-gray-900 focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors resize-none`}
            required={field.required}
          />
        ) : field.type === 'checkbox' ? (
          <div className="space-y-2">
            {field.options?.map(option => (
              <label key={option} className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  name={field.name}
                  value={option}
                  checked={value === option}
                  onChange={(e) => handleInputChange(field.name, e.target.value)}
                  className="w-4 h-4 text-green-600 border-gray-300 focus:ring-green-500"
                  required={field.required}
                />
                <span className="text-gray-700">{option}</span>
              </label>
            ))}
          </div>
        ) : (
          <input
            type={field.type}
            value={value}
            onChange={(e) => handleInputChange(field.name, e.target.value)}
            placeholder={field.placeholder}
            maxLength={field.name === 'dateOfBirth' ? 10 : undefined}
            className={`w-full px-4 py-2 sm:py-3 rounded-lg border ${hasError
              ? 'border-red-500'
              : 'border-gray-300'
              } bg-white text-gray-900 focus:ring-2 focus:ring-green-500 focus:border-transparent transition-colors`}
            required={field.required}
          />
        )
        }

        {hasError && (
          <p className="mt-1 text-sm text-red-500">{error}</p>
        )}
      </div>
    );
  };

  if (registrationSuccess) {
    const getRegistrationId = (resp) => {
      if (!resp) return null;
      if (typeof resp === 'string') return resp;
      return (
        resp.registrationId || resp.registration_id || resp.id || resp.regId || resp.data?.registrationId || resp.data?.id || null
      );
    };

    const regId = getRegistrationId(registrationResponse);
    return <RegistrationDone registrationId={regId} />;
  }

  return (
    <div className="min-h-screen bg-gray-300 flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-gray-700">
        <div className="container mx-auto px-4 sm:px-6 py-4">
          <div className="flex items-center justify-between flex-wrap gap-4">
            <div className="flex items-center gap-3 sm:gap-6">
              <button
                onClick={() => navigate(-1)}
                className="flex items-center gap-2 text-gray-500 hover:text-green-700 transition-colors"
              >
                <ArrowLeft className="w-4 h-4 sm:w-5 sm:h-5" />
                <span className="text-sm sm:text-base">Back</span>
              </button>
              <h1 className="text-xl sm:text-2xl font-bold text-green-700">EYES Ghana</h1>
            </div>
          </div>
        </div>
      </header>

      {/* Progress Bar */}
      <div className="bg-gray-800 border-b border-gray-700">
        <div className="container mx-auto px-4 sm:px-6 py-3">
          <div className="flex items-center justify-between mb-2">
            <p className="text-sm text-gray-300">
              Section {currentSection + 1} of {sections.length}
            </p>
            <p className="text-sm text-gray-300">
              {sections[currentSection].title}
            </p>
          </div>
          <div className="w-full bg-gray-700 rounded-full h-2">
            <div
              className="bg-green-600 h-2 rounded-full transition-all duration-300"
              style={{ width: `${((currentSection + 1) / sections.length) * 100}%` }}
            />
          </div>
        </div>
      </div>

      {/* Form*/}
      <div className="container mx-auto px-4 sm:px-6 py-6 sm:py-8 flex-grow">
        <div className="max-w-3xl mx-auto">
          <div className="bg-gray-100 rounded-lg shadow-2xl p-6 sm:p-8 md:p-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-green-800 mb-6 sm:mb-8">
              {sections[currentSection].title}
            </h2>

            <AnimatePresence mode="wait">
              <motion.div
                key={currentSection}
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ duration: 0.3 }}
              >
                <div className="space-y-4 sm:space-y-6">
                  {sections[currentSection].fields.map(field => renderField(field))}
                </div>
              </motion.div>
            </AnimatePresence>

            {errors.submit && (
              <div className="mt-4 p-4 bg-red-100 border border-red-400 rounded-lg">
                <p className="text-sm text-red-700">{errors.submit}</p>
              </div>
            )}

            <div className='text-center mt-12 text-gray-500 text-xs'>
              <p>
                {/* <strong>Prepared By: </strong> EYES-Ghana Baseline Team */}
              </p>
            </div>


            <div className="flex flex-col sm:flex-row gap-4 mt-8 sm:mt-10">
              {currentSection > 0 && (
                <motion.button
                  onClick={handlePrevious}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="flex-1 sm:flex-none sm:w-auto px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-semibold text-base sm:text-lg bg-gray-300 hover:bg-gray-400 text-gray-800 transition-colors"
                >
                  <div className="flex items-center justify-center gap-2">
                    <ArrowLeft className="w-5 h-5" />
                    <span>Previous</span>
                  </div>
                </motion.button>
              )}

              <motion.button
                onClick={currentSection === sections.length - 1 ? submitform : handleNext}
                disabled={isSubmitting}
                whileHover={{ scale: isSubmitting ? 1 : 1.02 }}
                whileTap={{ scale: isSubmitting ? 1 : 0.98 }}
                className={`flex-1 sm:flex-none sm:ml-auto sm:px-8 px-6 py-3 sm:py-4 rounded-lg font-semibold text-base sm:text-lg transition-all ${isSubmitting
                  ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                  : 'bg-green-900 hover:bg-green-700 text-white shadow-lg'
                  }`}
              >
                <div className="flex items-center justify-center gap-2">
                  <span>{currentSection === sections.length - 1 ? (isSubmitting ? 'Submitting...' : 'Submit') : 'Next'}</span>
                  {currentSection < sections.length - 1 && <ArrowRight className="w-5 h-5" />}
                </div>
              </motion.button>
            </div>
          </div>
        </div>
      </div>

      
    </div>
  );
};

export default RegistrationPage;